const INVALID_DOM_ID_CHARS = /[^A-Za-z0-9\-_:.]/g;

/**
 * React useId() can include ":" which is valid in HTML ids but can break
 * third-party scripts that naively build CSS selectors with `#${id}`.
 */
export function toDomSafeId(rawId: string, fallbackPrefix = 'id'): string {
  const normalized = rawId.replace(/:/g, '-').replace(INVALID_DOM_ID_CHARS, '-').trim();
  const collapsed = normalized.replace(/-+/g, '-').replace(/^-+|-+$/g, '');
  if (!collapsed) return `${fallbackPrefix}-generated`;
  if (!/^[A-Za-z_]/.test(collapsed)) return `${fallbackPrefix}-${collapsed}`;
  return collapsed;
}
